AFRAME.registerComponent('performance-tab', {
    schema: {
        ticker: { type: 'string', default: "AAPL" },
        prevClose: { type: 'number', default: 275.25 },
        open: { type: 'number', default: 0 },
        bid: { type: 'number', default: null },
        ask: { type: 'number', default: null },
        daysRange: { type: 'map', default: { low: 0, high: 0 } },
        range52Week: { type: 'map', default: { low: 169.21, high: 277.32 } },
        volume: { type: 'number', default: 0 },
        avgVolume: { type: 'number', default: 50892178 },
        marketCap: { type: 'number', default: 4067204100000 },
        sharesOutstanding: { type: 'number', default: 14776400000 },
        beta5YMonthly: { type: 'number', default: 1.109 },
        peRatioTTM: { type: 'number', default: 36.7339936166414 },
        epsTTM_Diluted: { type: 'number', default: 7.47 },
        forwardPERatioNTM: { type: 'number', default: 32.512402551382 },
        forecastEPSNQTR: { type: 'number', default: 2.62 },
        priceToSalesTTM: { type: 'number', default: 9.77315053548987 },
        priceToBookMRQ: { type: 'number', default: 55.8037055999349 },
        priceToFreeCashFlowTTM: { type: 'number', default: 41.6594067350431 },
        enterpriseValueToRevenueTTM: { type: 'number', default: 9.81902204795158 },
        enterpriseValueToEBITDA: { type: 'number', default: 27.9674098333414 },
        earningsDate: { type: 'string', default: "2026-01-29" },
        recentEarningsDate: { type: 'string', default: "2025-10-30" },
        nextEarningsDate: { type: 'string', default: "2026-01-29" },
        dividendDate: { type: 'string', default: '' },
        nextDividendDate: { type: 'string', default: '' },
        recentDividendDate: { type: 'string', default: "2025-11-10" },
        forwardDividendAndYield: { type: 'map', default: { annualDividendPerShare: 1.03, dividendYield: 0.00374205267938238 } },
        shortInterestRatio: { type: 'number', default: 0.782043231098238 },
        perfWeek: { type: 'number', default: null },
        perfMonth: { type: 'number', default: null },
        perf6M: { type: 'number', default: null },
        perfYTD: { type: 'number', default: null },
        perf1Y: { type: 'number', default: null },
        perf5Y: { type: 'number', default: null },

        companyLogo: { type: 'string', default: '#company-logo-temp' },
        tabIndex: { type: 'number', default: 0 },
    },

    init: function () {
        console.log('performance-tab: Initializing with data:', this.data);
        console.log('performance-tab: Element:', this.el);

        this.themeMode = 'Dark';
        try {
            const mainSettings = getCacheItem('mainSettings');
            if (mainSettings && mainSettings.themeMode) {
                this.themeMode = mainSettings.themeMode;
            }
        } catch (e) {
            console.warn('performance-tab: Failed to load theme settings', e);
        }

        window.addEventListener('theme-changed', (e) => {
            if (e.detail && e.detail.themeMode) {
                this.themeMode = e.detail.themeMode;
                this.createContent();
            }
        });

        this.navigation = this.el.querySelector('.performance-navigation')
        this.mainInfoBlock = this.el.querySelector('.main-info-block')
        this.priceSubtab = this.el.querySelector('.price-sub-tab')
        this.valuationSubtab = this.el.querySelector('.valuation-sub-tab')
        this.dividendsSubtab = this.el.querySelector('.dividends-sub-tab')
        this.returnsSubtab = this.el.querySelector('.returns-sub-tab')
        this.noStockMessage = this.el.querySelector('.no-stock-selected-message')
        this.subTabsList = []

        console.log('performance-tab: Found elements:', {
            navigation: !!this.navigation,
            mainInfoBlock: !!this.mainInfoBlock,
            priceSubtab: !!this.priceSubtab,
            valuationSubtab: !!this.valuationSubtab,
            dividendsSubtab: !!this.dividendsSubtab,
            returnsSubtab: !!this.returnsSubtab
        });

        if (!this.navigation || !this.mainInfoBlock || !this.priceSubtab || !this.valuationSubtab || !this.dividendsSubtab || !this.returnsSubtab) {
            console.error('performance-tab: Some required elements are missing!');
            console.error('performance-tab: Available children:', Array.from(this.el.children).map(child => child.className || child.tagName));
        }

        this.updateStockSelectionState()

        this.createContent()
        const self = this;
        this.el.addEventListener('performance-data-updated', function (event) {
            console.log('performance-tab: Received performance-data-updated event', event.detail);

            if (!event.detail) {
                console.warn('performance-tab: No data in performance-data-updated event');
                return;
            }

            if (!self.data) {
                console.warn('performance-tab: this.data is undefined, re-initializing');
                self.data = {};
                Object.keys(self.schema).forEach(key => {
                    self.data[key] = self.schema[key].default;
                });
            }

            Object.keys(event.detail).forEach(key => {
                if (self.data) {
                    self.data[key] = event.detail[key];
                }
            });

            console.log('performance-tab: Updated this.data from event:', self.data);
            console.log('performance-tab: Specific values in this.data:', {
                open: self.data.open,
                daysRange: self.data.daysRange,
                range52Week: self.data.range52Week,
                perfWeek: self.data.perfWeek,
                perfMonth: self.data.perfMonth,
                perf6M: self.data.perf6M,
                perf1Y: self.data.perf1Y,
                perf5Y: self.data.perf5Y
            });

            self.navigation = self.el.querySelector('.performance-navigation')
            self.mainInfoBlock = self.el.querySelector('.main-info-block')
            self.priceSubtab = self.el.querySelector('.price-sub-tab')
            self.valuationSubtab = self.el.querySelector('.valuation-sub-tab')
            self.dividendsSubtab = self.el.querySelector('.dividends-sub-tab')
            self.returnsSubtab = self.el.querySelector('.returns-sub-tab')
            self.subTabsList = []

            console.log('performance-tab: Elements before clearing:', {
                navigation: !!self.navigation,
                mainInfoBlock: !!self.mainInfoBlock,
                priceSubtab: !!self.priceSubtab,
                valuationSubtab: !!self.valuationSubtab,
                dividendsSubtab: !!self.dividendsSubtab,
                returnsSubtab: !!self.returnsSubtab
            });

            if (self.navigation) {
                while (self.navigation.firstChild) {
                    self.navigation.removeChild(self.navigation.firstChild);
                }
            }
            self.subTabsList = [];
            if (self.mainInfoBlock) self.mainInfoBlock.innerHTML = '';
            if (self.priceSubtab) self.priceSubtab.innerHTML = '';
            if (self.valuationSubtab) self.valuationSubtab.innerHTML = '';
            if (self.dividendsSubtab) self.dividendsSubtab.innerHTML = '';
            if (self.returnsSubtab) self.returnsSubtab.innerHTML = '';

            self.updateStockSelectionState();

            self.createContent();

            console.log('performance-tab: Content recreated after performance-data-updated event');
        });

        if (window.AutoRefreshScheduler && !this.performanceScheduler) {
            this.performanceScheduler = new window.AutoRefreshScheduler({
                name: 'PerformanceTabVR',
                scheduleType: 'interval',
                intervalMinutes: 5,
                onRefresh: () => {
                    const rightPanelDataHandlerEl = document.querySelector('[right-panel-data-handler]');
                    if (rightPanelDataHandlerEl && rightPanelDataHandlerEl.components && rightPanelDataHandlerEl.components['right-panel-data-handler']) {
                        const handler = rightPanelDataHandlerEl.components['right-panel-data-handler'];
                        const ticker = handler.currentTicker;
                        if (ticker) {
                            handler.updateDataForTicker(ticker);
                        }
                    }
                }
            });
            this.performanceScheduler.start();
        }
    },

    remove: function () {
        if (this.performanceScheduler) {
            this.performanceScheduler.stop();
        }
    },

    update: function (oldData) {
        console.log('performance-tab: Update called', {
            hasOldData: !!oldData,
            oldDataKeys: oldData ? Object.keys(oldData) : [],
            newDataKeys: Object.keys(this.data),
            newData: this.data
        });

        if (!oldData || Object.keys(oldData).length === 0) {
            console.log('performance-tab: Initial update, creating content');
            this.navigation = this.el.querySelector('.performance-navigation')
            this.mainInfoBlock = this.el.querySelector('.main-info-block')
            this.priceSubtab = this.el.querySelector('.price-sub-tab')
            this.valuationSubtab = this.el.querySelector('.valuation-sub-tab')
            this.dividendsSubtab = this.el.querySelector('.dividends-sub-tab')
            this.returnsSubtab = this.el.querySelector('.returns-sub-tab')
            this.noStockMessage = this.el.querySelector('.no-stock-selected-message')
            this.subTabsList = []
            this.updateStockSelectionState()
            this.createContent();
            return;
        }

        const fieldsToCheck = [
            'ticker', 'companyLogo', 'prevClose', 'open', 'bid', 'ask',
            'daysRange', 'range52Week', 'volume', 'avgVolume', 'marketCap',
            'sharesOutstanding', 'beta5YMonthly', 'peRatioTTM', 'epsTTM_Diluted',
            'forwardPERatioNTM', 'forecastEPSNQTR', 'priceToSalesTTM', 'priceToBookMRQ',
            'priceToFreeCashFlowTTM', 'enterpriseValueToRevenueTTM', 'enterpriseValueToEBITDA',
            'earningsDate', 'forwardDividendAndYield', 'dividendDate', 'shortInterestRatio',
            'perfWeek', 'perfMonth', 'perf6M', 'perfYTD', 'perf1Y', 'perf5Y'
        ];

        let hasChanges = false;
        const changes = {};

        fieldsToCheck.forEach(key => {
            const newVal = this.data[key];
            const oldVal = oldData[key];

            const normalize = (val) => {
                if (val === null || val === undefined) return '';
                if (typeof val === 'object') return JSON.stringify(val);
                if (typeof val === 'number') return String(val);
                return String(val).trim();
            };

            const newValNorm = normalize(newVal);
            const oldValNorm = normalize(oldVal);

            if (newValNorm !== oldValNorm) {
                hasChanges = true;
                changes[key] = { old: oldVal, new: newVal };
            }
        });

        if (hasChanges) {
            console.log('performance-tab: Data changed, updating content', {
                changes: changes,
                oldData: oldData,
                newData: this.data
            });

            this.navigation = this.el.querySelector('.performance-navigation')
            this.mainInfoBlock = this.el.querySelector('.main-info-block')
            this.priceSubtab = this.el.querySelector('.price-sub-tab')
            this.valuationSubtab = this.el.querySelector('.valuation-sub-tab')
            this.dividendsSubtab = this.el.querySelector('.dividends-sub-tab')
            this.returnsSubtab = this.el.querySelector('.returns-sub-tab')
            this.subTabsList = []

            if (this.mainInfoBlock) this.mainInfoBlock.innerHTML = '';
            if (this.priceSubtab) this.priceSubtab.innerHTML = '';
            if (this.valuationSubtab) this.valuationSubtab.innerHTML = '';
            if (this.dividendsSubtab) this.dividendsSubtab.innerHTML = '';
            if (this.returnsSubtab) this.returnsSubtab.innerHTML = '';

            this.createContent()
        } else {
            console.log('performance-tab: No changes detected', {
                oldData: oldData,
                newData: this.data
            });
        }
    },

    createContent: function () {
        console.log('performance-tab: createContent called');
        const self = this;
        const url = this.data.companyLogo;
        const isRealUrl = url && url !== '#company-logo-temp' && url !== '' && !url.startsWith('#');

        if (isRealUrl) {
            const tester = new Image();
            tester.onload = () => self._renderContent(true);
            tester.onerror = () => self._renderContent(false);
            tester.src = url;
        } else {
            this._renderContent(false);
        }
    },

    _renderContent: function (hasLogo) {


        if (!this.navigation) this.navigation = this.el.querySelector('.performance-navigation');
        if (!this.mainInfoBlock) this.mainInfoBlock = this.el.querySelector('.main-info-block');
        if (!this.priceSubtab) this.priceSubtab = this.el.querySelector('.price-sub-tab');
        if (!this.valuationSubtab) this.valuationSubtab = this.el.querySelector('.valuation-sub-tab');
        if (!this.dividendsSubtab) this.dividendsSubtab = this.el.querySelector('.dividends-sub-tab');
        if (!this.returnsSubtab) this.returnsSubtab = this.el.querySelector('.returns-sub-tab');

        this.createNavigationButtons()
        this.createBody(hasLogo)
    },
    createNavigationButtons: function () {
        if (!this.navigation) {
            console.warn('performance-tab: navigation element not found');
            return;
        }

        while (this.navigation.firstChild) {
            this.navigation.removeChild(this.navigation.firstChild);
        }
        this.subTabsList = [];

        const buttonWidth = 0.05;
        const buttonHeight = buttonWidth * 0.4;
        const spacing = 0.01;

        const startX = -0.09;
        const startY = -0.02;
        const z = 0.03;
        const subTabNames = ['Price', 'Valuation', 'Dividends', 'Returns']

        subTabNames.forEach((name, index) => {
            const x = startX + index * (buttonWidth + spacing);
            const position = `${x} ${startY} ${z}`;

            const button = document.createElement("a-entity");
            button.setAttribute("ui-button", {
                label: name,
                type: "rounded-box",
                width: buttonWidth,
                height: buttonHeight,
                depth: 0.02,
                color: "#191920",
                opacity: 0.8,
                autosize: false,
                isSelectable: true,
                selectedColor: "#3636E3",
                radius: Math.min(buttonWidth, buttonHeight) * 0.3,
                preferredFontSize: 0.008,
            });
            button.setAttribute("position", position);
            button.setAttribute("data-raycastable", "");
            this.subTabsList.push(button);

            this.navigation.appendChild(button);

            button.addEventListener("click", () => {
                this.selectSubTab(button, index)

                const prettyGEventName = ['Price', 'Valuation', 'Dividends', 'Returns']
                if (window.gtag) gtag('event', `VR_RightPanel_Performance_${prettyGEventName[index]}`);
            });
        })
        const indexToSelect = (typeof this.selectedTabIndex === 'number' && this.selectedTabIndex < this.subTabsList.length) ? this.selectedTabIndex : 0;
        this.selectSubTab(this.subTabsList[indexToSelect], indexToSelect);

    },

    createBody: function (hasLogo) {
        const textColor = this.themeMode === 'Light' ? '#14141C' : '#FFFFFF';
        const isLight = this.themeMode === 'Light';
        const labelColor = isLight ? '#8C8C8C' : '#FFFFFF';
        const labelOpacity = isLight ? '1' : '0.5';

        if (!this.mainInfoBlock) {
            console.error('performance-tab: mainInfoBlock not found');
            return;
        }
        if (!this.priceSubtab) {
            console.error('performance-tab: priceSubtab not found');
            return;
        }
        if (!this.valuationSubtab) {
            console.error('performance-tab: valuationSubtab not found');
            return;
        }
        if (!this.dividendsSubtab) {
            console.error('performance-tab: dividendsSubtab not found');
            return;
        }
        if (!this.returnsSubtab) {
            console.error('performance-tab: returnsSubtab not found');
            return;
        }

        this.mainInfoBlock.innerHTML = ''
        this.mainInfoBlock.setAttribute('position', '0 -0.03 0')

        if (hasLogo) {
            const logo = document.createElement('a-image');
            logo.setAttribute('src', this.data.companyLogo);
            logo.setAttribute('width', 0.04);
            logo.setAttribute('height', 0.04);
            logo.setAttribute('transparent', true);
            logo.setAttribute('material', 'alphaTest: 0.1');
            logo.setAttribute('position', `-0.075 -0.025 0`)
            this.mainInfoBlock.appendChild(logo)
        }

        const companyName = document.createElement('a-text');
        companyName.setAttribute('value', this.data.ticker);
        // title.setAttribute('font-size', 0.05);
        companyName.setAttribute('scale', '0.05 0.05 0.05');
        companyName.setAttribute('color', textColor);
        companyName.setAttribute('anchor', 'left');
        companyName.setAttribute('position', `${hasLogo ? -0.04 : -0.075} -0.025 0`)
        companyName.setAttribute('width', 3)
        companyName.setAttribute('wrap-count', 24)
        companyName.setAttribute('line-height', 60)
        this.mainInfoBlock.appendChild(companyName);

        this.priceSubtab.innerHTML = ''
        this.priceSubtab.setAttribute('position', '0 -0.11 0')
        createLine('Prev close', this.data.prevClose, this.formatCurrency, 0, 0.06, this.priceSubtab);
        createLine('Open', this.data.open, this.formatCurrency, -0.02, 0.03, this.priceSubtab);
        // createLine('Bid', this.data.bid, this.formatCurrency, -0.04, 0.02, this.priceSubtab);
        // createLine('Ask', this.data.ask, this.formatCurrency, -0.06, 0.025, this.priceSubtab);

        const daysRangeLow = this.data.daysRange?.low !== null && this.data.daysRange?.low !== undefined ? this.formatCurrency(this.data.daysRange.low) : 'N/A';
        const daysRangeHigh = this.data.daysRange?.high !== null && this.data.daysRange?.high !== undefined ? this.formatCurrency(this.data.daysRange.high) : 'N/A';
        createLine('Days range', `${daysRangeLow} - ${daysRangeHigh}`, null, -0.04, 0.06, this.priceSubtab);

        const range52Low = this.data.range52Week?.low !== null && this.data.range52Week?.low !== undefined ? this.formatCurrency(this.data.range52Week.low) : 'N/A';
        const range52High = this.data.range52Week?.high !== null && this.data.range52Week?.high !== undefined ? this.formatCurrency(this.data.range52Week.high) : 'N/A';
        createLine('52w Range', `${range52Low} - ${range52High}`, null, -0.06, 0.06, this.priceSubtab);

        createLine('Volume', this.data.volume, this.formatNumber, -0.08, 0.04, this.priceSubtab);
        createLine('Avg. Volume', this.data.avgVolume, this.formatNumber, -0.10, 0.065, this.priceSubtab);
        createLine('Market cap', this.data.marketCap, this.formatCurrency, -0.12, 0.06, this.priceSubtab);
        createLine('Short interest', this.data.shortInterestRatio * 100, this.formatPercentageSimple, -0.14, 0.075, this.priceSubtab);

        this.valuationSubtab.innerHTML = ''
        this.valuationSubtab.setAttribute('position', '0 -0.11 0')
        createLine('Shares outstanding', this.data.sharesOutstanding, this.formatNumber, 0, 0.10, this.valuationSubtab);
        createLine('Beta', this.data.beta5YMonthly, this.formatRatio, -0.02, 0.03, this.valuationSubtab);
        createLine('PE ratio', this.data.peRatioTTM, this.formatRatio, -0.04, 0.045, this.valuationSubtab);
        createLine('EPS (TTM)', this.data.epsTTM_Diluted, this.formatCurrency, -0.06, 0.06, this.valuationSubtab);
        createLine('Forward PE ratio', this.data.forwardPERatioNTM, this.formatRatio, -0.08, 0.085, this.valuationSubtab);
        createLine('Forecast EPS (QTR)', this.data.forecastEPSNQTR, this.formatCurrency, -0.1, 0.1, this.valuationSubtab);
        createLine('Price to sales', this.data.priceToSalesTTM, this.formatRatio, -0.12, 0.07, this.valuationSubtab);
        createLine('Price to book', this.data.priceToBookMRQ, this.formatRatio, -0.14, 0.07, this.valuationSubtab);
        createLine('Price to free cash flow', this.data.priceToFreeCashFlowTTM, this.formatRatio, -0.16, 0.14, this.valuationSubtab);
        createLine('Enterprise value/Revenue', this.data.enterpriseValueToRevenueTTM, this.formatRatio, -0.18, 0.15, this.valuationSubtab);
        createLine('Enterprise value/EBITDA', this.data.enterpriseValueToEBITDA, this.formatRatio, -0.2, 0.15, this.valuationSubtab);

        this.dividendsSubtab.innerHTML = ''
        this.dividendsSubtab.setAttribute('position', '0 -0.11 0')
        createLine('Earnings date', this.data.earningsDate, this.formatDate, 0, 0.075, this.dividendsSubtab);
        const annualDiv = this.data.forwardDividendAndYield && this.data.forwardDividendAndYield.annualDividendPerShare !== null && this.data.forwardDividendAndYield.annualDividendPerShare !== undefined ? this.formatCurrency(this.data.forwardDividendAndYield.annualDividendPerShare) : 'N/A';
        const divYield = this.data.forwardDividendAndYield && this.data.forwardDividendAndYield.dividendYield !== null && this.data.forwardDividendAndYield.dividendYield !== undefined ? this.formatPercentageSimple(this.data.forwardDividendAndYield.dividendYield * 100) : 'N/A';
        createLine('Dividend (TTM) and Yield', `${annualDiv} & ${divYield}`, null, -0.02, 0.13, this.dividendsSubtab);
        createLine('Dividend date', this.data.dividendDate, this.formatDate, -0.04, 0.075, this.dividendsSubtab);

        this.returnsSubtab.innerHTML = ''
        this.returnsSubtab.setAttribute('position', '0 -0.11 0')

        createLine('Perf week', this.data.perfWeek, this.prettifyPercentage, 0, 0.055, this.returnsSubtab);
        createLine('Perf Month', this.data.perfMonth, this.prettifyPercentage, -0.02, 0.06, this.returnsSubtab);
        createLine('Perf 6M', this.data.perf6M, this.prettifyPercentage, -0.04, 0.045, this.returnsSubtab);
        createLine('Perf YTD', this.data.perfYTD, this.prettifyPercentage, -0.06, 0.05, this.returnsSubtab);
        createLine('Perf 1Y', this.data.perf1Y, this.prettifyPercentage, -0.08, 0.04, this.returnsSubtab);
        createLine('Perf 5Y', this.data.perf5Y, this.prettifyPercentage, -0.10, 0.04, this.returnsSubtab);


        function createLine(label, value, formatter, yPosition, valueXOffset = 0, parentEl) {
            let displayValue = value;
            if (formatter && typeof formatter === 'function') {
                displayValue = formatter(value);
            } else if (value === null || value === undefined) {
                if (formatter === null) displayValue = value;
                else displayValue = 'N/A';
            } else {
                displayValue = value;
            }

            const lineContainer = document.createElement('a-entity');
            lineContainer.setAttribute('position', `0 ${yPosition} 0`)
            parentEl.appendChild(lineContainer)

            const labelEl = document.createElement('a-text');
            labelEl.setAttribute('value', label);
            labelEl.setAttribute('scale', '0.05 0.05 0.05');
            labelEl.setAttribute('opacity', labelOpacity);
            labelEl.setAttribute('color', labelColor);
            labelEl.setAttribute('anchor', 'left');
            labelEl.setAttribute('position', '-0.1 0 0');
            lineContainer.appendChild(labelEl);

            const valueEl = document.createElement('a-text');
            valueEl.setAttribute('value', displayValue);
            valueEl.setAttribute('scale', '0.05 0.05 0.05');
            valueEl.setAttribute('color', textColor);
            valueEl.setAttribute('anchor', 'left');
            valueEl.setAttribute('position', `${-0.1 + valueXOffset} 0 0`);
            lineContainer.appendChild(valueEl);
        }

    },

    selectSubTab: function (subTabEl, selectedSubTabIndex) {
        this.selectedTabIndex = selectedSubTabIndex;
        this.subTabsList.forEach((btn) => {
            if (btn && btn !== subTabEl) {
                btn.setAttribute("ui-button", "selected", false);
                btn.setAttribute("scale", "1 1 1");
            }
        });
        subTabEl.setAttribute("ui-button", "selected", true);
        subTabEl.setAttribute("scale", "1.05 1.05 1.05");

        const subTabs = [this.priceSubtab, this.valuationSubtab, this.dividendsSubtab, this.returnsSubtab]
        subTabs.forEach((subTab, subTabIndex) => {
            if (subTab) subTab.setAttribute("visible", selectedSubTabIndex === subTabIndex);
        })
    },

    isValidNumber: function (val) {
        return val !== null && val !== undefined && typeof val === 'number' && !isNaN(val);
    },

    formatCurrency: function (initialNumber) {
        if (initialNumber === null || initialNumber === undefined || typeof initialNumber !== 'number' || isNaN(initialNumber)) return 'N/A';
        let number = initialNumber;
        const suffixes = ['', 'K', 'M', 'B', 'T'];
        let suffixIndex = 0;
        const isNegative = number < 0;
        number = Math.abs(number);

        if (number === 0) return '$0.00';

        while (number >= 1000 && suffixIndex < suffixes.length - 1) {
            number /= 1000;
            suffixIndex++;
        }

        const sign = isNegative ? '-' : '';
        return `${sign}$${number.toFixed(2)}${suffixes[suffixIndex]}`;
    },

    formatNumber: function (initialNumber) {
        if (initialNumber === null || initialNumber === undefined || typeof initialNumber !== 'number' || isNaN(initialNumber)) return 'N/A';
        let number = initialNumber;
        const suffixes = ['', 'K', 'M', 'B', 'T'];
        let suffixIndex = 0;
        const isNegative = number < 0;
        number = Math.abs(number);

        if (number === 0) return '0.00';

        while (number >= 1000 && suffixIndex < suffixes.length - 1) {
            number /= 1000;
            suffixIndex++;
        }
        const sign = isNegative ? '-' : '';
        return `${sign}${number.toFixed(2)}${suffixes[suffixIndex]}`;
    },

    formatRatio: function (initialNumber) {
        if (initialNumber === null || initialNumber === undefined || typeof initialNumber !== 'number' || isNaN(initialNumber)) return 'N/A';
        return initialNumber.toFixed(2);
    },

    formatDate: function (dateStr) {
        if (!dateStr || dateStr === 'null' || dateStr === 'N/A') return 'N/A';
        const parts = dateStr.split('-');
        if (parts.length === 3) {
            const [y, m, d] = parts;
            if (!isNaN(y) && !isNaN(m) && !isNaN(d)) {
                return `${m}-${d}-${y.slice(-2)}`;
            }
        }
        return dateStr;
    },

    formatPercentageSimple: function (initialNumber) {
        if (initialNumber === null || initialNumber === undefined || typeof initialNumber !== 'number' || isNaN(initialNumber)) return 'N/A';
        return `${initialNumber.toFixed(2)}%`;
    },

    prettifyPercentage: function (value) {
        if (value === null || value === undefined) return 'N/A'

        if (typeof value !== 'number') return 'N/A'

        if (isNaN(value)) return 'N/A'

        const sign = value >= 0 ? '+' : ''
        const arrow = value >= 0 ? '↑' : '↓'
        return `${sign}${value.toFixed(2)}% ${arrow}`
    },

    updateStockSelectionState: function () {
        let hasStock = false;
        const rightPanelDataHandler = document.querySelector('[right-panel-data-handler]');
        if (rightPanelDataHandler && rightPanelDataHandler.components && rightPanelDataHandler.components['right-panel-data-handler']) {
            const ticker = rightPanelDataHandler.components['right-panel-data-handler'].currentTicker;
            hasStock = !!ticker;
        }

        if (!hasStock && this.data.ticker) {
            hasStock = this.data.ticker !== 'AAPL' &&
                this.data.ticker.trim() !== '' &&
                this.data.ticker !== this.schema.ticker.default;
        }

        if (this.noStockMessage) {
            this.noStockMessage.setAttribute('visible', !hasStock);
        }

        if (this.navigation) {
            this.navigation.setAttribute('visible', hasStock);
        }
        if (this.mainInfoBlock) {
            this.mainInfoBlock.setAttribute('visible', hasStock);
        }
        if (this.priceSubtab) {
            this.priceSubtab.setAttribute('visible', hasStock ? '' : false);
        }
        if (this.valuationSubtab) {
            this.valuationSubtab.setAttribute('visible', hasStock ? false : false);
        }
        if (this.dividendsSubtab) {
            this.dividendsSubtab.setAttribute('visible', hasStock ? false : false);
        }
        if (this.returnsSubtab) {
            this.returnsSubtab.setAttribute('visible', hasStock ? false : false);
        }
    }
})
